import RefreshIcon from "@mui/icons-material/Refresh";
import ClearIcon from "@mui/icons-material/Clear";
import { MenuAction } from "../components/shared/step-content-box";

interface CreateFieldMenuActionsParams {
  onRefresh: () => void;
  onClearSelection: () => void;
}

const createFieldMenuActions = ({
  onRefresh,
  onClearSelection,
}: CreateFieldMenuActionsParams): MenuAction[] => [
  {
    label: "Refresh Fields",
    icon: <RefreshIcon />,
    onClick: onRefresh,
  },
  {
    label: "Clear Selection",
    icon: <ClearIcon />,
    onClick: onClearSelection,
  },
];

export default createFieldMenuActions;
